import { Directive, Input, TemplateRef, Type, ViewContainerRef } from "@angular/core";
import { PermissionConditionSet, PermissionService } from "../services/permission.service";
import { NoAccessComponent } from "../components/no-access/no-access.component";

@Directive({
  standalone: true,
  selector: "[RequiresPermission]]",
})
export class RequiresPermissionDirective {
  @Input() RequiresPermission: PermissionConditionSet = { permissionIds: [], type: 'any' };
  @Input() RequiresPermissionFallback?: boolean = false;
  @Input() RequiresPermissionFallbackComponent!: Type<any>;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {
  }

  ngOnInit(): void {
    this.updateView();
  }

  private updateView(): void {
    this.viewContainer.clear();
    const hasPermission = this.permissionService.evaluatePermissionsForLoggedInUser(this.RequiresPermission);
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else if (this.RequiresPermissionFallback && this.RequiresPermissionFallbackComponent) {
      this.viewContainer.createComponent(this.RequiresPermissionFallbackComponent);
    }else if(this.RequiresPermissionFallback){
      this.viewContainer.createComponent(NoAccessComponent);
    }
  }

}
